import {findScrollParent} from "./find_scroll_parent";

// Distance between the top of the element and the top of its scrolling ancestor (0 when there is none).
export const getOffsetInScrollParent = (element: HTMLElement) => {
    const scroller = findScrollParent(element);

    if (!scroller) return 0;

    return Math.max(0, element.getBoundingClientRect().top - scroller.getBoundingClientRect().top);
};
import {findScrollParent} from "./find_scroll_parent";

// Distance between the top of the element and the top of its scrolling ancestor (0 when there is none).
export const getOffsetInScrollParent = (element: HTMLElement) => {
    const scroller = findScrollParent(element);

    if (!scroller) return 0;

    return Math.max(0, element.getBoundingClientRect().top - scroller.getBoundingClientRect().top);
};
